import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CountryProps } from "../types/attribute/countryProps";
import { api } from "../services/api.service";

export const fetchCountries = createAsyncThunk<CountryProps[], { query: string }>(
  "fetch/country",
  async ({ query }) => {
    const data = await api.attribute.country.getAll({ name: query });
    return data as CountryProps[];
  }
);

interface CountryState {
  countries: CountryProps[];
  country: null | CountryProps;
  loading: boolean;
  error: null | string;
}

const initialState: CountryState = {
  countries: [],
  country: null,
  loading: false,
  error: null,
};

export const countrySlice = createSlice({
  name: "country",
  initialState: initialState,
  reducers: {
    addCountry: (state, action: PayloadAction<CountryProps>) => {
      state.countries.push(action.payload);
    },
    removecountry: (state, action: PayloadAction<{ id: number }>) => {
      state.countries = state.countries.filter(
        (country) => country.id !== action.payload.id
      );
    },
    updatecountry: (state, action: PayloadAction<CountryProps>) => {
      state.countries = state.countries.map((country) =>
        country.id === action.payload.id ? action.payload : country
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.countries = action.payload;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addCountry, removecountry, updatecountry } =
  countrySlice.actions;

export default countrySlice.reducer;
